import { BigNum, QUOTE_PRECISION_EXP } from '@drift-labs/sdk';
import React from 'react';
import useSettleAllPnls from 'src/hooks/drift-actions/useSettlePnls';
import {
	useCurrentAccountMarginInfo,
	useMarginInfoByUserKey,
} from 'src/hooks/query/accountTradingData/useMarginInfo';

export interface UnsettledPnlData {
	unsettledNumber: number;
	hasUnsettled: boolean;
	handleSettleNow: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

export default function useUnsettledPnl(userKey?: string): UnsettledPnlData {
	const currentAccountMarginInfo = useCurrentAccountMarginInfo();
	const targetAccountMarginInfo = useMarginInfoByUserKey(userKey).data;
	const marginInfo = userKey
		? targetAccountMarginInfo
		: currentAccountMarginInfo;
	const { settleAllPnls } = useSettleAllPnls(userKey);
	const unsettledBN = marginInfo?.totalUnsettledPnl;

	const unsettledNumber = unsettledBN
		? BigNum.from(unsettledBN, QUOTE_PRECISION_EXP).toNum()
		: 0;

	const handleSettleNow = (e: React.MouseEvent<HTMLButtonElement>) => {
		e.preventDefault();
		settleAllPnls();
	};

	return {
		unsettledNumber,
		hasUnsettled: !!unsettledBN && unsettledNumber > 0,
		handleSettleNow,
	};
}
